import { render, staticRenderFns } from "./Auftrag_Sammelrechnung.vue?vue&type=template&id=61026414&scoped=true"
import script from "./Auftrag_Sammelrechnung.vue?vue&type=script&lang=js"
export * from "./Auftrag_Sammelrechnung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61026414",
  null
  
)

export default component.exports